import React from "react";

export default function DeliveryDetails() {
  return (
    <form className="mx-2">
      <div class="relative z-0 w-full mb-1 group">
        <input
          type="text"
          name="Name"
          class="block py-2.5 px-0 w-full text-sm text-gray-50 bg-transparent border-0 border-b-2 border-gray-200 appearance-none  focus:outline-none focus:ring-0 focus:border-blue-900 peer placeholder-gray-50"
          placeholder="Delivery Name "
          required
        />
      </div>
      <div class="relative z-0 w-full mb-6 group">
        <select
          id="items"
          class=" border mt-8 border-gray-200 text-gray-50 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full py-3 placeholder-gray-50"
          placeholder=" "
          required
        >
          <option selected>Select Items/Assemblies</option>
          <option value="US">ABC</option>
          <option value="CA">XYZ</option>
          <option value="FR">ABC</option>
          <option value="DE">XYZ</option>
        </select>
      </div>
      <div class="relative z-0 w-full mb-1 group">
        <input
          type="number"
          name="QTY"
          class="block py-2.5 px-0 w-full text-sm text-gray-50 bg-transparent border-0 border-b-2 border-gray-200 appearance-none  focus:outline-none focus:ring-0 focus:border-blue-900 peer placeholder-gray-50"
          placeholder="Quantity "
          required
        />
      </div>
      <div class="relative z-0 w-full mb-6 group">
        <input
          type="date"
          name="date"
          class="block mt-8 py-2.5 px-0 w-full text-sm text-gray-50 rounded-md bg-transparent border border-gray-200 appearance-none  focus:outline-none focus:ring-0 focus:border-blue-900 peer placeholder-gray-50"
          placeholder="Dispatch Date "
          required
        />
      </div>
      <div class="relative z-0 w-full mb-6 group">
        <select
          id="customers"
          class=" border mt-8 border-gray-200 text-gray-50 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full py-3 placeholder-gray-50"
          placeholder=" "
          required
        >
          <option selected>Select Customer</option>
          <option value="US">ABC</option>
          <option value="CA">XYZ</option>
          <option value="FR">ABC</option>
          <option value="DE">XYZ</option>
        </select>
      </div>
    </form>
  );
}
